import PropTypes from 'prop-types'

const propTypes = {
  closeHandler: PropTypes.func.isRequired,
}

export default propTypes
